<template>
  <div class="mt-3">
    <a-form-model
      ref="form"
      :model="form">
      <j-input
        v-for="input in manifest.integration.input"
        v-model="form[input.code]"
        :key="input.code"
        :prop="input.code"
        :label="input.name"
        :placeholder="input.sample"
        :icon="input.icon"
        :type="inputType(input)"
        :rules="rules(input)" />
      <div
        class="mb-3"
        v-if="isShopify">
        <a-form-model-item
          :colon="false"
          class="mb-3">
          <span slot="label" class="text-dark">{{ $t('msg.shop.action.startUrl') }}</span>
          <div class="d-flex align-items-center justify-content-between">
            <span>{{ manifest.shopify_start_url }}</span>
            <a-button
              size="small"
              icon="copy"
              @click="onCopy(manifest.shopify_start_url)">
              {{ $t('msg.shop.action.copy') }}
            </a-button>
          </div>
        </a-form-model-item>
        <a-form-model-item
          :colon="false"
          class="mb-0">
          <span slot="label" class="text-dark">{{ $t('msg.shop.action.callbackUrl') }}</span>
          <div class="d-flex align-items-center justify-content-between">
            <span>{{ manifest.shopify_callback_url }}</span>
            <a-button
              size="small"
              icon="copy"
              @click="onCopy(manifest.shopify_callback_url)">
              {{ $t('msg.shop.action.copy') }}
            </a-button>
          </div>
        </a-form-model-item>
      </div>
      <a-button
        class="mt-4"
        type="primary"
        size="large"
        v-if="!isShopify"
        @click="onSubmit">
        {{ $t('msg.shop.action.connect') }}
      </a-button>
      <a-button
        class="mt-4 ml-2"
        size="large"
        v-if="isShopify"
        @click="onSaveCredentials">
        {{ $t('msg.shop.action.saveCredentials') }}
      </a-button>

      <a-button
        class="mt-4"
        type="link"
        size="large"
        v-if="manifest.academy_url">
        <a :href="manifest.academy_url" target="_blank">
        {{ $t('msg.shop.action.tutorial') }}
        </a>
      </a-button>
    </a-form-model>
  </div>
</template>
<script>
import v from '@/utils/validators'
import JInput from '@/views/shared/forms/input'
import lms from '@/api/lms'
export default {
  name: 'IntForm',
  components: {
    JInput,
  },
  props: {
    manifest: Object,
  },
  data: function () {
    return {
      v,
      form: {},
    }
  },
  computed: {
    isShopify() {
      return this.manifest.code === 'SHF'
    },
  },
  methods: {
    onCopy(value) {
      navigator.clipboard.writeText(value)
      this.$message.success(this.$t('msg.copied'))
    },
    inputType(input) {
      return input.code === 'secret' ? 'password' : input.type
    },
    rules(input) {
      const rules = [v.required]
      switch (input.type) {
        case 'email':
          rules.push(v.email)
          break
        case 'number':
          rules.push(v.number)
          break
        case 'url':
          rules.push(v.url)
          break
      }
      return rules
    },
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          const query = { type: this.manifest.code, account: this.account, ...this.form }
          this.$router.push({ path: '/shops/callback', query })
        }
      })
    },
    onSaveCredentials() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (!this.account) {
            this.$message.error('No se encontro account_id para guardar credenciales')
            return
          }
          const payload = { ...this.form, account_id: this.account }
          lms.platform.saveCredentials(this.account, payload)
            .then(_ => {
              this.$message.success(this.$t('msg.shop.action.credentialsSaved'))
              this.$router.replace({ path: '/shops', query: { account: this.account } })
            })
            .catch(_ => {
              this.$message.error(this.$t('msg.shop.action.credentialsFailed'))
            })
        }
      })
    },
  },
}
</script>
